<template>
	<div class="cover cat-animation" :class="[idleClass, state]"></div>
</template>

<script>
import random from '@/mixins/random';
import { whichAnimationIteration } from '@/mixins/event-detection';

const animationIteration = whichAnimationIteration();

export default {
	name: 'BaseAnimation',
	mixins: [random],
	props: ["state"],
	data() {
		return {
			idleClass: "idle",
			idleAnimations: ["idle", "idle-blink", "idle-meow"],
		};
	},
	watch: {
		state(currentState, formerState) {
			if (currentState === "fed" && currentState !== formerState) {
				this.$el.addEventListener(animationIteration, this.randomizeIdle);
			} else if (formerState === "fed" && currentState !== formerState) {
				this.$el.removeEventListener(animationIteration, this.randomizeIdle);
			}

			if (currentState === "death") {
				this.idleClass = "";
			}
		},
	},
	methods: {
		randomizeIdle() {
			this.idleClass = this.randomValue(this.idleAnimations);
		},
	},
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/cat/BaseAnimation.vue